import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNumberCircleTwo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 19,
	viewBox: "0 0 16 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8 15.5322C11.3137 15.5322 14 12.8459 14 9.53223C14 6.21852 11.3137 3.53223 8 3.53223C4.68629 3.53223 2 6.21852 2 9.53223C2 12.8459 4.68629 15.5322 8 15.5322Z",
		stroke: "currentColor",
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.61875 7.45097C6.75356 7.13263 6.99418 6.87063 7.29992 6.70928C7.60567 6.54794 7.95776 6.49715 8.29663 6.56551C8.63551 6.63388 8.94037 6.81719 9.15965 7.08445C9.37892 7.35172 9.49915 7.68651 9.5 8.03222C9.50135 8.33089 9.41199 8.62293 9.24375 8.86972V8.86972L6.5 12.5322H9.5",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgNumberCircleTwo;
